/**
 * ProgressBar Component
 * Simple progress bar for file uploads
 */

export default function ProgressBar({ progress = 0, label = "Progreso" }) {
  return (
    <div style={{ width: '100%' }}>
      {label && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          marginBottom: '8px' 
        }}>
          <span className="kicker">{label}</span>
          <span className="kicker">{Math.round(progress)}%</span>
        </div>
      )}
      <div style={{
        width: '100%',
        height: '8px',
        background: 'var(--primary)',
        borderRadius: '999px',
        overflow: 'hidden'
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          background: '#4f6cf7',
          transition: 'width 0.3s ease',
          borderRadius: '999px'
        }} />
      </div>
    </div>
  );
}
